export default __webpack_public_path__ + "static/media/wish.3ac5c9f0.svg";